import _extends from "@babel/runtime/helpers/extends";
import { Box, Text, Tooltip } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import styles from './CycleSelectorBadge.scss';
export const CycleSelectorBadgeUi = _ref => {
  let {
    dataHook,
    tooltipDataHook,
    isSelected,
    skin = 'default',
    text,
    tooltipContent,
    onShowTooltip,
    ...boxProps
  } = _ref;
  if (!text) {
    return null;
  }
  const handleShowTooltip = () => {
    onShowTooltip == null || onShowTooltip(tooltipContent);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: tooltipDataHook,
    content: tooltipContent,
    disabled: !tooltipContent,
    onShow: handleShowTooltip
  }, /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: dataHook,
    align: "center",
    padding: "1px 4px",
    borderRadius: "4px",
    className: classNames(styles.cycleSelectorBadge, styles[skin], {
      [styles.filled]: isSelected
    })
  }, boxProps), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold",
    className: styles.text
  }, text)));
};
//# sourceMappingURL=CycleSelectorBadgeUi.js.map